exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 768px) {\n    .columnGroup-root-1tm {\n        flex-wrap: wrap;\n    }\n}\n", ""]);

// Exports
exports.locals = {
	"root": "columnGroup-root-1tm"
};